import { buildLabelIndex, findLabelEntry, resolveLabel } from "./labelLookup";

// Anzeigenamen der Materialkategorien (materials.category) und der
// Materialsektoren (material_sectors.name). Beide stehen in der Datenbank nur
// auf Deutsch (teils englisch) und überschneiden sich stark, daher eine
// gemeinsame Tabelle. Schlüssel = exakter Datenbankwert.
// Neue Werte in der DB hier ergänzen; der Test in
// src/utils/materialLabels.test.js prüft gegen die DB-Werte in
// src/utils/__fixtures__/taxonomyDbValues.json.
export const MATERIAL_TERMS = {
  "Agrar / Lebensmittel": { en: "Agriculture / Food", zh: "农业 / 食品" },
  "Aluminium": { en: "Aluminium", zh: "铝", alt: ["Aluminum"] },
  "Baustoffe/Holz /Verpackung": { en: "Building Materials / Wood / Packaging", zh: "建材 / 木材 / 包装" },
  "Blei": { en: "Lead", zh: "铅" },
  "Chemikalien": { en: "Chemicals", zh: "化学品", alt: ["化工"] },
  "Chemikalien / Kunststoffe": { en: "Chemicals / Plastics", zh: "化学品 / 塑料" },
  "Chemische Grundstoffe": { en: "Basic Chemicals", zh: "基础化学品" },
  "Edelmetalle": { en: "Precious Metals", zh: "贵金属" },
  "Edelstahl": { en: "Stainless Steel", zh: "不锈钢" },
  "Eisenerz": { en: "Iron Ore", zh: "铁矿石" },
  "Elastomere": { en: "Elastomers", zh: "弹性体" },
  "Energie": { en: "Energy", zh: "能源" },
  "Energy": { en: "Energy", zh: "能源", de: "Energie" },
  "Erneuerbare": { en: "Renewables", zh: "可再生能源" },
  "Ferrolegierungen": { en: "Ferroalloys", zh: "铁合金" },
  "Finanzmärkte": { en: "Financial Markets", zh: "金融市场" },
  "Flachstahl": { en: "Flat Steel", zh: "板材", alt: ["扁钢", "扁平材"] },
  "Fracht": { en: "Freight", zh: "货运", alt: ["货物"] },
  "Fracht / Logistik": { en: "Freight / Logistics", zh: "货运 / 物流" },
  "Freight": { en: "Freight", zh: "货运", de: "Fracht" },
  "Gas": { en: "Gas", zh: "天然气" },
  "Graphit": { en: "Graphite", zh: "石墨" },
  "Holz": { en: "Wood", zh: "木材" },
  "Koks / Kokskohle": { en: "Coke / Coking Coal", zh: "焦炭 / 焦煤" },
  "Kraftstoffe": { en: "Fuels", zh: "燃料" },
  "Kunststoffe": { en: "Plastics", zh: "塑料" },
  "Kupfer": { en: "Copper", zh: "铜" },
  "Landwirtschaft": { en: "Agriculture", zh: "农业" },
  "Langstahl": { en: "Long Steel", zh: "长材", alt: ["长材钢"] },
  "Legierungszuschläge": { en: "Alloy Surcharges", zh: "合金附加费" },
  "Logistik": { en: "Logistics", zh: "物流" },
  "Makroökonomie": { en: "Macroeconomics", zh: "宏观经济" },
  "MBI Stahlindizes /-statistiken": { en: "MBI Steel Indices / Statistics", zh: "MBI 钢铁指数 / 统计" },
  "Messing / Bronze": { en: "Brass / Bronze", zh: "黄铜 / 青铜" },
  "Metalle": { en: "Metals", zh: "金属" },
  "Monomere": { en: "Monomers", zh: "单体" },
  "Nebenmetalle": { en: "Minor Metals", zh: "小金属", alt: ["副金属"] },
  "NE-Metalle": { en: "Non-Ferrous Metals", zh: "有色金属" },
  "NE-Metals": { en: "Non-Ferrous Metals", zh: "有色金属", de: "NE-Metalle" },
  "Nicht zugewiesen": { en: "Unassigned", zh: "未分配" },
  "Nickel": { en: "Nickel", zh: "镍" },
  "Öl": { en: "Oil", zh: "石油" },
  "Papier": { en: "Paper", zh: "纸张" },
  "Pflanzliche Rohstoffe": { en: "Plant-Based Commodities", zh: "植物类原料", alt: ["Plant Raw Materials", "植物原料"] },
  "Polymers": { en: "Polymers", zh: "聚合物", de: "Polymere" },
  "REE": { en: "Rare Earth Elements", zh: "稀土", de: "Seltene Erden", alt: ["稀土元素"] },
  "Roheisen": { en: "Pig Iron", zh: "生铁" },
  "Rohre": { en: "Pipes / Tubes", zh: "钢管", alt: ["管材"] },
  "Sonstiges": { en: "Other", zh: "其他" },
  "Stahl": { en: "Steel", zh: "钢铁" },
  "Stahlschrott": { en: "Steel Scrap", zh: "废钢" },
  "Standardthermoplaste": { en: "Commodity Thermoplastics", zh: "通用热塑性塑料", alt: ["Standard Thermoplastics", "标准热塑性塑料"] },
  "Steel": { en: "Steel", zh: "钢铁", de: "Stahl" },
  "Strom": { en: "Electricity", zh: "电力" },
  "Technische Kunststoffe": { en: "Engineering Plastics", zh: "工程塑料" },
  "Tierische Rohstoffe": { en: "Animal-Based Commodities", zh: "动物类原料", alt: ["Animal Raw Materials", "动物原料"] },
  "Umwelt": { en: "Environment", zh: "环境" },
  "Viehwirtschaft": { en: "Livestock", zh: "畜牧业" },
  "Wechselkurse / Devisen": { en: "Exchange Rates / FX", zh: "汇率 / 外汇", alt: ["Exchange Rates / Foreign Exchange"] },
  "Wirtschaftsindikatoren": { en: "Economic Indicators", zh: "经济指标" },
  "Wood": { en: "Wood", zh: "木材", de: "Holz" },
  "Zink": { en: "Zinc", zh: "锌" },
  "Zinn": { en: "Tin", zh: "锡" },
  "Zuschläge": { en: "Surcharges", zh: "附加费" },
};

const CATEGORY_INDEX = buildLabelIndex(MATERIAL_TERMS);

// Anzeigename einer Materialkategorie in der Sprache `lang` ("de"|"en"|"zh",
// auch "zh-CN" o.ä.). Leere Werte kommen unverändert zurück, unbekannte
// Werte als Rohwert.
export function categoryLabel(category, lang) {
  if (category == null || String(category).trim() === "") return category;
  return resolveLabel(CATEGORY_INDEX, category, lang);
}

export function hasCategoryLabel(category) {
  return findLabelEntry(CATEGORY_INDEX, category) != null;
}
